package core.dateformat.data

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import core.dateformat.domain.DateFormat

object DateConfig {
    var dateFormat by mutableStateOf(DateFormat.MONTH_DAY.format)
        private set

    fun update(date: String) {
        dateFormat = date
    }
}